<template>
  <div class="form-group lm-text-input" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      v-if="label"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <lm-dropdown
      v-if="isEditableByPickedUser"
      class="float-right"
      :tooltip="!disableEditors ? 'Selecciona quién edita este campo' : null"
      template="user-list"
      @input="$emit('editor-change', $event)"
      :value="collaborator"
      :disabled="disableEditors"
      closeAfterPick
    >
      <div class="d-flex align-items-center gap-2">
        {{ collaborator.name || '' }}
        <a-icon type="edit" v-if="!disableEditors" />
      </div>
    </lm-dropdown>
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft, 'mode-items-input-list': modeItemsInputList,}" class="position-relative">
      <input
        :autofocus="autofocus"
        :value="itemSelected || value"
        @keyup.enter.exact="$emit('enter')"
        @input="onInput($event)"
        @focusout="validateOnfocusOutMethod"
        class="form-control"
        ref="lmTextInput"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        type="text"
        :id="idComputed"
        :disabled="disabled || isProcessingInputList"
        :maxlength="maxLength"
        @blur="formatValue($event)"
        />
      <template v-if="modeItemsInputList">
        <LmButton
          @click.native="onSearch"
          type="Button"
          value="Buscar"
          :isProcessing="isProcessingInputList"
          lmButtonRootWrapperClass="d-inline-block m-0 p-0"
          lmButtonWrapperClass="m-0 p-0"
          buttonClass="btn-primary position-relative search-button"
        />
        <b-list-group
          id="input-list"
          class="input-list"
          v-if="!showNoFoundItemMessage"
          >
          <b-list-group-item
            :disabled="isProcessingInputList"
            tabindex="0"
            class="item"
            v-for="(item, index) in itemsInputListData"
            :key="`item-${index}`"
            @click="itemWasSeleted(item)"
            @keyup.enter.exact="itemWasSeleted(item)"
            >{{item.text}}</b-list-group-item>
        </b-list-group>
        <b-list-group
          id="input-list-no-found-message"
          class="input-list"
          v-if="showNoFoundItemMessage"
          >
          <b-list-group-item
            class="item not-found"
            >{{noFoundItemMessage}}</b-list-group-item>
        </b-list-group>
      </template>
      <p class="invalid-feedback" v-if="validation.hasError"> {{ showValidationErrorMessage }} </p>
    </div>
  </div>

</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
// Utils
import lmInputMixin from '@/mixins/lmInputMixin'
export default {
  mixins: [lmInputMixin],
  data () {
    return {
      showNoFoundItemMessage: false,
      itemSelected: '',
      valueData: '',
      itemsInputListData: []
    }
  },
  components: {
    LmButton
  },
  props: {
    noFoundItemMessage: {
      type: String,
      default: 'No se encontraron items'
    },
    isProcessingInputList: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 100
    },
    itemsInputList: {
      type: Array,
      default: () => []
    },
    modeItemsInputList: {
      type: Boolean,
      default: false
    },
    isApiPath: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatValue (value) {
      this.$emit('blur')
      if (this.isApiPath) {
        let val = value.target.value
        if (!/^\/\S*/.test(val)) {
          val = '/' + val
        }
        if (!/\S*\/$/.test(val)) {
          val = val + '/'
        }
        value.target.value = val
        this.onInput(value)
      }
    },
    itemWasSeleted (item) {
      this.$emit('itemWasSeleted', item)
      this.itemSelected = item.text
      this.itemsInputListData = []
    },
    onInput (value) {
      this.itemSelected = ''
      this.valueData = value.target.value
      this.$emit('input', value.target.value)
    },
    onSearch () {
      this.$emit('search', this.valueData)
    }
  },
  watch: {
    itemsInputList () {
      this.itemsInputListData = this.itemsInputList
      if (this.itemsInputListData.length) {
        this.showNoFoundItemMessage = false
      } else {
        this.showNoFoundItemMessage = true
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.input-list
  position: absolute
  z-index: 9999999
  background: white
  top: 38px
  width: 100%
  max-height: 415px
  overflow: auto
  .item
    &:hover
      background: #f8f9fa
      cursor: pointer
    &.not-found
      background: inherit
      cursor: default
.mode-items-input-list
  display: flex
  border-radius: 0.25rem 0 0 0.25rem
::v-deep
  .search-button
    height: 38px
    border-radius: 0 0.25rem 0.25rem 0
</style>
